import React from "react"
import { Banner, Problem, Speech, Study, Summary } from "components/Home"


export const HomePage = () => {
    return (
        <div>
            <Banner/>
            <Problem/>
            <Summary/>
            <Study/>
            <Speech/>
        </div>
    )
}